/**
 * Глобальная блокировка вывода в консоль браузера
 * 
 * Чтобы включить блокировку, установите CONSOLE_BLOCKED в true
 * Чтобы отключить блокировку, установите CONSOLE_BLOCKED в false
 */

// ============================================
// НАСТРОЙКА: измените это значение для включения/отключения блокировки
// ВАЖНО: основная блокировка применяется в public/index.html через inline script
// Это дополнительная блокировка на случай, если что-то пропустило первую
// ============================================
const CONSOLE_BLOCKED = false; // true = блокировка включена, false = блокировка выключена (ВРЕМЕННО ОТКЛЮЧЕНО ДЛЯ ОТЛАДКИ)
// ============================================

// Сохраняем оригинальные методы console ДО того, как что-либо может их использовать
const originalConsole = {
    log: console.log.bind(console),
    error: console.error.bind(console),
    warn: console.warn.bind(console),
    info: console.info.bind(console),
    debug: console.debug.bind(console),
    trace: console.trace.bind(console),
    table: console.table.bind(console),
    group: console.group.bind(console),
    groupEnd: console.groupEnd.bind(console),
    groupCollapsed: console.groupCollapsed.bind(console),
    time: console.time.bind(console),
    timeEnd: console.timeEnd.bind(console),
    assert: console.assert.bind(console),
    clear: console.clear.bind(console),
    count: console.count.bind(console),
    dir: console.dir.bind(console),
    dirxml: console.dirxml.bind(console),
    profile: console.profile.bind(console),
    profileEnd: console.profileEnd.bind(console)
};

// Пустые функции для замены
const noop = () => {};

// Функция для включения блокировки
const enableConsoleBlock = () => {
    try {
        Object.defineProperty(window, 'console', {
            value: {
                ...originalConsole,
                log: noop,
                error: noop,
                warn: noop,
                info: noop,
                debug: noop,
                trace: noop,
                table: noop,
                group: noop,
                groupEnd: noop,
                groupCollapsed: noop,
                time: noop,
                timeEnd: noop,
                assert: noop,
                clear: noop,
                count: noop,
                dir: noop,
                dirxml: noop,
                profile: noop,
                profileEnd: noop
            },
            writable: false,
            configurable: false
        });
    } catch (e) {
        // Если не удалось переопределить через defineProperty, используем обычное присваивание
        console.log = noop;
        console.error = noop;
        console.warn = noop;
        console.info = noop;
        console.debug = noop;
        console.trace = noop;
        console.table = noop;
        console.group = noop;
        console.groupEnd = noop;
        console.groupCollapsed = noop;
        console.time = noop;
        console.timeEnd = noop;
        console.assert = noop;
        console.clear = noop;
        console.count = noop;
        console.dir = noop;
        console.dirxml = noop;
        console.profile = noop;
        console.profileEnd = noop;
    }
};

// Функция для отключения блокировки (восстановление оригинальных методов)
const disableConsoleBlock = () => {
    try {
        Object.defineProperty(window, 'console', {
            value: originalConsole,
            writable: false,
            configurable: false
        });
    } catch (e) {
        // Если не удалось переопределить через defineProperty, используем обычное присваивание
        console.log = originalConsole.log;
        console.error = originalConsole.error;
        console.warn = originalConsole.warn;
        console.info = originalConsole.info;
        console.debug = originalConsole.debug;
        console.trace = originalConsole.trace;
        console.table = originalConsole.table;
        console.group = originalConsole.group;
        console.groupEnd = originalConsole.groupEnd;
        console.groupCollapsed = originalConsole.groupCollapsed;
        console.time = originalConsole.time;
        console.timeEnd = originalConsole.timeEnd;
        console.assert = originalConsole.assert;
        console.clear = originalConsole.clear;
        console.count = originalConsole.count;
        console.dir = originalConsole.dir;
        console.dirxml = originalConsole.dirxml;
        console.profile = originalConsole.profile;
        console.profileEnd = originalConsole.profileEnd;
    }
};

// Применяем блокировку НЕМЕДЛЕННО при загрузке модуля
if (CONSOLE_BLOCKED) {
    enableConsoleBlock();
}

// Экспортируем функции для ручного управления
export { enableConsoleBlock, disableConsoleBlock, CONSOLE_BLOCKED };

